export const JOB_LOAD_REQUEST = "JOB_LOAD_REQUEST";
export const JOB_LOAD_SUCCESS = "JOB_LOAD_SUCCESS";
export const JOB_LOAD_FAIL = "JOB_LOAD_FAIL";
export const JOB_LOAD_RESET = "JOB_LOAD_RESET";

export const JOB_LOAD_SINGLE_REQUEST = "JOB_LOAD_SINGLE_REQUEST";
export const JOB_LOAD_SINGLE_SUCCESS = "JOB_LOAD_SINGLE_SUCCESS";
export const JOB_LOAD_SINGLE_FAIL = "JOB_LOAD_SINGLE_FAIL";
export const JOB_LOAD_SINGLE_RESET = "JOB_LOAD_SINGLE_RESET";

export const JOB_CREATE_LOAD = "JOB_CREATE_LOAD";
export const JOB_CREATE_REQUEST = "JOB_CREATE_REQUEST";
export const JOB_CREATE_SUCCESS = "JOB_CREATE_SUCCESS";
export const JOB_CREATE_FAIL = "JOB_CREATE_FAIL";